import React, { useEffect, useState } from "react";
import { getTicketSearchFields } from "../../api/ticketsApi";
import { sessionVariables } from "../util/constants";

const MyTicketSearch = ({ onSearch }) => {
  const [searchText, setSearchText] = useState("");
  const [defaultSearchFieldsJson, setDefaultSearchFieldsJson] = useState([]);
  const [defaultSearchFields, setDefaultSearchFields] = useState([]);

  const [SelectedProgressStatus, setSelectedProgressStatus] = useState("");
  const [SelectedPriorityType, setSelectedPriorityType] = useState("");
  const [SelectedCategoryType, setSelectedCategoryType] = useState("");
  const [SelectedHeadType, setSelectedHeadType] = useState("");

  const [searchForJson, setSearchForJson] = useState([]);
  const [selectedSearchType, setSelectedSearchType] = useState(searchForJson?.[0] || "All");
  const [createdByText, setCreatedByText] = useState("");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const user = JSON.parse(sessionStorage.getItem("lgusr"));
  const orgId = user?.orgId;

  useEffect(() => {
    if (orgId) {
      fetchTicketSearchFields();
    }
  }, [orgId]);

  const fetchTicketSearchFields = async () => {
    setLoading(true);
    const searchFormConfig = JSON.parse(sessionStorage.getItem(sessionVariables.sv_TicketSearchJson));
    if (searchFormConfig && searchFormConfig.inputTypes && searchFormConfig.searchForJson) {
      setLoading(false);
      setDefaultSearchFieldsJson(searchFormConfig.inputTypes);
      setSearchForJson(searchFormConfig.searchForJson);
    } else {
      console.log("not found");
      try {
        const res = await getTicketSearchFields(orgId);
        if (res && Array.isArray(res.inputTypes) && Array.isArray(res.searchForJson)) {
          sessionStorage.setItem(sessionVariables.sv_TicketSearchJson, JSON.stringify({
            inputTypes: res.inputTypes,
            searchForJson: res.searchForJson
          }));
          setDefaultSearchFieldsJson(res.inputTypes);
          setSearchForJson(res.searchForJson);
          setSelectedSearchType(res.searchForJson?.[0] || "All");
        } else {
          setError("Invalid API response.");
        }
      } catch (err) {
        setError("Failed to load search fields. Please try again later.");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleDropdownChange = (field, value) => {
    switch (field) {
      case "PROGRESS_STATUS":
        setSelectedProgressStatus(value);
        break;
      case "PRIORITY":
        setSelectedPriorityType(value);
        break;
      case "CATEGORY":
        setSelectedCategoryType(value);
        break;
      case "HEAD":
        setSelectedHeadType(value);
        break;
      default:
        break;
    }
  };

  const handleSearch = () => {
    onSearch({
      searchText,
      createdByText,
      searchType: selectedSearchType,
      defaultSearchFields: {
        progressStatus: SelectedProgressStatus,
        priorityStatus: SelectedPriorityType,
        category: SelectedCategoryType,
        headType: SelectedHeadType,
      },
      isCreatedBy: false,
    });
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin h-6 w-6 border-t-2 border-b-2 border-blue-500 rounded-full"></div>
        <span className="ml-2">Generating Search Panel</span>
      </div>
    );
  }

  // Show error state
  if (error) {
    return <div className="text-red-500 text-center py-8">{error}</div>;
  }

  return (
    <>
      <div className="flex flex-col w-full mx-auto p-6 mb-4 bg-white shadow-md rounded-lg">
        <div className="flex flex-wrap items-center gap-4">
          <div className="flex-grow min-w-[150px]">
            <input
              type="text"
              placeholder="Search..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="w-full border p-2 rounded-md focus:ring-blue-500 focus:border-blue-500"
              aria-label="Search tickets"
            />
          </div>
          <div>
            <select
              value={selectedSearchType}
              onChange={(e) => setSelectedSearchType(e.target.value)}
              className="p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">{`Search For`}</option>
              {searchForJson.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
          {defaultSearchFieldsJson.length > 0 ? (
            defaultSearchFieldsJson.map((field, index) => (
              <div key={index} className="min-w-[150px] flex-grow">
                {field.type === "DROPDOWN" ? (
                  <select
                    key={field.label}
                    onChange={(e) => handleDropdownChange(field.label, e.target.value)}
                    className="mt-1 block w-full border p-2 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    aria-label={`Select ${field.label}`}
                    disabled={!field.options || field.options.length === 0}
                  >
                    <option value="">{`Select ${field.label}`}</option>
                    {field.options?.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                ) : null}
              </div>
            ))
          ) : (
            <div className="text-gray-500 text-sm">
              No search filters available at the moment.
            </div>
          )}
          {/* Search Button */}
          <div>
            <button
              onClick={handleSearch}
              className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition duration-300"
              aria-label="Submit search"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
export default MyTicketSearch;

